export const OCPP_VERSION_OPTIONS = [
    { value: "ocpp1.6", label: "OCPP 1.6" },
    { value: "ocpp2.0.1", label: "OCPP 2.0.1" },
];

export const DEFAULT_OCPP_VERSION = "ocpp1.6";

export const STATION_MAX_PROFILE_PURPOSES = [
    "ChargePointMaxProfile",
    "ChargingStationMaxProfile",
];

export const isOcpp201 = (ocppVersion) =>
    String(ocppVersion || "").toLowerCase() === "ocpp2.0.1";

export const normalizeOcppVersion = (ocppVersion) => {
    const version = String(ocppVersion || "").trim().toLowerCase();
    return version === "" ? DEFAULT_OCPP_VERSION : version;
};

export const hasMixedOcppVersions = (chargingPoints) => {
    const versions = new Set(
        (chargingPoints ?? []).map((cp) => normalizeOcppVersion(cp?.ocppVersion))
    );
    return versions.size > 1;
};

export const isStationMaxProfile = (purpose) =>
    STATION_MAX_PROFILE_PURPOSES.includes(String(purpose || ""));

export const toBasicAuthPasswordInput = (value) =>
    String(value || "").toUpperCase();

export const hasBasicAuthPassword = (basicAuthPassword) =>
    String(basicAuthPassword || "").trim().length > 0;

export const requiresBasicAuthPassword = (ocppVersion, basicAuthPassword) =>
    isOcpp201(ocppVersion) && !hasBasicAuthPassword(basicAuthPassword);

export const requiresBasicAuthPasswordOnUpdate = (
    ocppVersion,
    originalOcppVersion,
    basicAuthPassword
) =>
    isOcpp201(ocppVersion)
    && !isOcpp201(originalOcppVersion)
    && !hasBasicAuthPassword(basicAuthPassword);

// EncryptionHelper uppercases before encrypt; generate uppercase + digits so round-trip matches.
export const generateBasicAuthPassword = (length = 16) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const bytes = crypto.getRandomValues(new Uint8Array(length));
    return Array.from(bytes, (b) => chars[b % chars.length]).join("");
};
